import { createSlice } from '@reduxjs/toolkit'


export const resultsSlice = createSlice({
    name: 'results',
    initialState: {
        items: {},
        loading: false,
        error: null,
        xAxis: "date",
        yAxis: "max",
    },
    reducers: {
        setResults: (state, action) => {
            state.items[action.payload.id] = {
                items: action.payload?.items?.items?.filter((e) => !(e?.deleted ?? true)),
                hasMore: action.payload?.items?.hasMore,
                lastEvaluatedKey: action.payload?.items?.lastEvaluatedKey
            };
            state.loading = false;
            state.error = null;
        },
        appendResults: (state, action) => {
            state.items[action.payload.id].items = state.items[action.payload.id]?.items?.concat(action.payload.items?.items?.filter((e) => !(e?.deleted ?? true)))
            state.items[action.payload.id].hasMore = action.payload.items?.hasMore ?? false
            state.items[action.payload.id].lastEvaluatedKey = action.payload.items?.lastEvaluatedKey
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        updateResult: (state, action) => {
            const updatedItem = action.payload
            const exercise = updatedItem.exercise;
            const index = state.items[exercise].items.findIndex((element) => (element.id === updatedItem.id))
            state.items[exercise].items[index] = updatedItem
        },
        deleteCheckedResults: (state, action) => {
            const itemsToDelete = action.payload.items;
            const exercise = action.payload.exercise;
            if (itemsToDelete.length) {
                const items = new Set(itemsToDelete)
                const filtered = state.items[exercise]?.items.filter((element) => (!items.has(element.id)))
                state.items[exercise].items = filtered
            }
        },
        addNewResult: (state, action) => {
            const itemToAdd = action.payload;
            const exercise = itemToAdd.exercise;
            state.items[exercise].items.push(itemToAdd)
        },
        setXAxis: (state, action) => {
            state.xAxis = action.payload
        },
        setYAxis: (state, action) => {
            state.yAxis = action.payload
        },
        forgetResults: (state, action) => {

            state.items = {}

        }
    },

});
export const { setResults, setLoading, setError, updateResult, deleteCheckedResults, setXAxis, setYAxis, addNewResult, appendResults, forgetResults } = resultsSlice.actions
export default resultsSlice.reducer;